// Temporary flag for enabling podme integration
const getPodmeIntegrationFlag = (): boolean => {
    try {
        return window.localStorage.getItem('enablePodmeIntegration') === 'true';
    } catch {
        return false;
    }
};

export const isPodmeIntegrationEnabled = getPodmeIntegrationFlag();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function isLinodeUploadEnabled(provider: string) {
    // return ['ap', 'bt', 'sa'].includes(provider);
    return true;
}

const getNewLivePageFlag = (): boolean => {
    try {
        return window.localStorage.getItem('enableNewLivePageV2') === 'true';
    } catch {
        return false;
    }
};

export const isNewLivePageEnabled = getNewLivePageFlag();
